// ponytail: copy of app-module-order-page-approve/form/orders.js, with the invoice-email
// send-on-success logic copied from app-module-order-page-confirmation/form/orders_corp_collection.js
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { observer, useObserver } from "mobx-react-lite";
import Moment from "react-moment";

import { Row, Col } from "reactstrap";

/* design */
import DesignSection from "../../app-design-section";
/* design */

/* packages */
import { Inputs, Buttons, Invalid } from "../../lib-atomic";
import { FormHook, LocalStorage } from "../../lib-atomic-functions";
import { FetchContextApi } from "../../lib-atomic-functions";
import {
  ModuleTitle,
  ModuleLink,
  ModuleText,
  ModuleImage,
} from "../../lib-atomic-design-section";
import { PDFBlobProviderInvoiceCorp } from "../../app-module-order-page-pdf/program";
/* packages */

/* module */
import ProductDetail from "../../app-module-product-detail/detail";
/* module */

/* stores */
import {
  OrderApprove,
  OrderEmailInvoice,
} from "../../app-module-order-container/stores";
/* stores */

import CONFIG from "../config";

/* CONSTANTS */
const LANDINGGRAPHICS = CONFIG.setup.assets.landing.default;
const APPROVE = CONFIG.application.order.api.endpoints.approve;
const APPROVECONFIG = {
  url: APPROVE.url,
  method: APPROVE.method,
  headers: APPROVE.headers,
  responseType: "json",
};
const SENDATTACHMENT = CONFIG.application.order.api.endpoints.sendattachment;
const SENDATTACHMENTCONFIG = {
  url: SENDATTACHMENT.url,
  method: SENDATTACHMENT.method,
  headers: SENDATTACHMENT.headers,
  responseType: "formdata",
};
/* CONSTANTS */

const index = ({ props, previewData, order }) => {
  const { token } = LocalStorage.getLS().login;
  const orderId = order.id;

  /* states */
  APPROVECONFIG.headers = { ...APPROVECONFIG.headers, Authorization: token };
  const [orderApproveContext, orderApproveMethod] = FetchContextApi(
    APPROVECONFIG,
    OrderApprove,
  );
  const [orderEmailInvoiceContext, orderEmailInvoiceMethod] = FetchContextApi(
    SENDATTACHMENTCONFIG,
    OrderEmailInvoice,
  );
  /* states */

  async function prepareBlob(previewData) {
    return await PDFBlobProviderInvoiceCorp(previewData);
  }

  const handleApprove = async () => {
    await orderApproveMethod({ query: orderId + "/cc-approve" });
    if (orderApproveContext.status) {
      // if order approved then send invoice in email
      prepareBlob(previewData).then(async (blobPrepared) => {
        let formData = new FormData();
        formData.append("file", blobPrepared);
        const fullName =
          previewData.pdfPreviewData.contactInfoData.firstName +
          " " +
          previewData.pdfPreviewData.contactInfoData.lastName;
        const emailAddress =
          previewData.pdfPreviewData.companyInfoData.clients[0].emailAddress;
        const dataEmail = {
          templateId: "c270c690-d80f-4c37-b160-1aacf888ae86",
          fullName,
          emailAddress,
          params: {
            name: fullName,
            order_number: orderId,
          },
        };
        formData.append("data", JSON.stringify(dataEmail));
        await orderEmailInvoiceMethod({
          body: formData,
        });

        props.history.push("/orders/l/success-quote-approve/" + orderId);
      });
    }
  };

  const handleCancel = async () => {
    props.history.push("/orders/detail/" + orderId);
  };

  /* data props */
  const submitButton = { size: "small", onClick: handleApprove };
  const cancelButton = { size: "small", onClick: handleCancel };
  /* data props */

  return (
    <Fragment>
      <img src={LANDINGGRAPHICS} width="100%" />
      <ModuleTitle>Almost there!</ModuleTitle>
      <ModuleText>
        You are about to approve order number <b>{orderId}</b>. Would you like
        to proceed?
      </ModuleText>
      <br />
      <br />
      <Buttons.Primary {...submitButton}>Proceed and approve</Buttons.Primary>
      <Buttons.Text {...cancelButton}>Cancel</Buttons.Text>
    </Fragment>
  );
};

export default index;
